import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';

import { FormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';
import { UiFactory } from '../../core/ui/ui-factory';
import { PgButtonComponent } from '../pg-button.component';
import { BehaviorService } from '../../core/behavior/behavior.service';
import { ButtonModel } from './button-model';

@Component({
  selector: 'pg-button-factory, grit-button-factory',
  templateUrl: './pg-button-factory.component.html',
  styleUrls: ['./pg-button-factory.component.scss'],
})
export class PgButtonFactoryComponent extends UiFactory {
  @Input('model')
  model: any;

  formValid: boolean;
  fgSubscription: Subscription;

  @Input() parentFormGroup: FormGroup;

  @ViewChild(PgButtonComponent, { static: true })
  buttonChild: PgButtonComponent;

  get buttonModel(): ButtonModel {
    return this.model;
  }

  constructor(
    public behaviorService: BehaviorService,
    public cdRef: ChangeDetectorRef
  ) {
    super(behaviorService);
  }

  async handleButtonClicked(event) {
    await this.behaviorService.execute(this.buttonModel.onClick, {
      target: this,
      targetModel: this.buttonModel,
      formGroup: this.parentFormGroup,
    });
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.parentFormGroup) {
      this.formValid = this.parentFormGroup.valid;
      this.fgSubscription = this.parentFormGroup.statusChanges.subscribe(s => {
        this.formValid = s === 'VALID';
        this.cdRef.detectChanges();
      });
    }
  }

  ngOnDestroy() {
    if (this.fgSubscription && !this.fgSubscription.closed) {
      this.fgSubscription.unsubscribe();
    }
  }
}
